import { AppDataHttpService, AppStateService } from "@core/data";
import { CurrentUserModel } from '@core/data/models';
import { UserLoggedInMessage } from '@core/messages';

import { Messenger } from '@shared/data/messaging';

import { UserAvatarUpdatedMessage } from '@app-common/components/user-dialog/messages';
import { ToastLevel, ToastMessage } from '@app/components/notification';
import { UserUpdatedNotification, UserAvatarUpdatedNotification } from '@app/security-common/data/http';

export class CurrentUserStateHandler {
  public initialize(
    appStateService: AppStateService,
    messenger: Messenger,
    appDataHttpService: AppDataHttpService) {

    messenger.subscribe(appStateService, UserLoggedInMessage, async (message: UserLoggedInMessage) => {
      if (!message?.User) return;

      const currentUser = CurrentUserModel.fromToken(message.User);
      appStateService.CurrentUser.set(currentUser);

      if (!currentUser.id) return;

      try {
        const avatarResult = appDataHttpService.getCurrentUserAvatar(currentUser.id);
        const avatarResponse = await avatarResult.response;
        currentUser.avatar.set(avatarResponse?.avatar ?? null);
      }
      catch (error) {
        console.warn('CurrentUserStateHandler: Failed to initialize current user avatar', error);
      }
    });

    messenger.subscribe(appStateService, UserUpdatedNotification, (message: UserUpdatedNotification) => {
      const currentUser = appStateService.CurrentUser();
      if (!currentUser?.id || currentUser.id !== message.userId) return;

      if (message.userName) currentUser.name.set(message.userName);
      for (const change of message.changes) {
        switch (change.propertyName.toLowerCase()) {
          case 'firstname': currentUser.firstName.set(change.newValue); break;
          case 'lastname': currentUser.lastName.set(change.newValue); break;
          case 'fullname': currentUser.name.set(change.newValue); break;
          case 'email':
          case 'username': currentUser.email.set(change.newValue); break;
          case 'avatar': currentUser.avatar.set(change.newValue); break;
        }
      }
    });

    messenger.subscribe(appStateService, UserAvatarUpdatedNotification, (message: UserAvatarUpdatedNotification) => {
      const currentUser = appStateService.CurrentUser();
      if (!currentUser?.id || currentUser.id !== message.userId) return;

      currentUser.avatar.set(message.avatar ?? null);
      messenger.send(ToastMessage.create(
        new UserAvatarUpdatedMessage(currentUser.name(), message.avatar ?? null),
        ToastLevel.Information,
      ));
    });
  }
}